import { render, staticRenderFns } from "./IPQCExamine.vue?vue&type=template&id=70acd2a6&scoped=true"
import script from "./IPQCExamine.vue?vue&type=script&lang=js"
export * from "./IPQCExamine.vue?vue&type=script&lang=js"
import style0 from "./IPQCExamine.vue?vue&type=style&index=0&id=70acd2a6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70acd2a6",
  null
  
)

export default component.exports